export default {
	COLORS: {
		// tag color constants
		DEFAULT: 'ddd', // #ddd
		POSITIVE: '8AD09E', // #8AD09E
		NEGATIVE: 'ff7476', // #ff7476
	},
};
